(ns iris.components.simple-modal
  (:require
  ;;  [herb.core :refer [<class <id]]
   [iris.styles.simple-modal :as $styles]))



(defn simple-modal [title content width on-click-close-handler]
  [:div {:class
        ;;  (<class $styles/modal true)
         $styles/$modal
         }
   [:div {:class
          ;; (<class $styles/modal-content width)
          $styles/$modal-content
          :style {:max-width (str width "px")}}
    [:div {:class
           ;;  (<class $styles/top-bar)
           $styles/$top-bar}
     [:span {:class
            ;;  (<class $styles/title)
             $styles/$title
             } title]
     [:span {:title (str "Close " title)
             :class
             ;;  (<class $styles/close-btn)
             $styles/$close-btn
             :on-click on-click-close-handler} "x"]]
    [:div {:class
           ;;  (<class $styles/child-content)
           $styles/$child-content}
     content]]])